import { useEffect } from "react";
import { useSettings } from "../hooks/useSettings";
import { updateMetaTags } from "../utils/seo";

const DynamicSEO = () => {
  const { getFreeDeliveryThreshold, getDeliveryLimit } = useSettings();

  useEffect(() => {
    const freeDeliveryThreshold = getFreeDeliveryThreshold();
    const deliveryLimit = getDeliveryLimit();

    // Update default meta tags with dynamic values
    const defaultDescription = `Buy premium quality rice online at Grainly. Fresh Basmati, Sona Masoori, and more varieties. Same-day delivery within ${deliveryLimit}km. Free delivery on orders ≥ ₹${freeDeliveryThreshold}. Order now!`;

    updateMetaTags({
      description: defaultDescription,
    });

    // Update Open Graph description
    const ogDescription = `Buy premium quality rice online at Grainly. Fresh Basmati, Sona Masoori, and more varieties. Same-day delivery within ${deliveryLimit}km. Free delivery on orders ≥ ₹${freeDeliveryThreshold}.`;

    // Update Twitter description
    const twitterDescription = `Buy premium quality rice online. Fresh Basmati, Sona Masoori, and more. Same-day delivery. Free delivery on orders ≥ ₹${freeDeliveryThreshold}.`;

    // Update meta tags
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute("content", defaultDescription);
    }

    const ogDescriptionMeta = document.querySelector(
      'meta[property="og:description"]'
    );
    if (ogDescriptionMeta) {
      ogDescriptionMeta.setAttribute("content", ogDescription);
    }

    const twitterDescriptionMeta = document.querySelector(
      'meta[property="twitter:description"]'
    );
    if (twitterDescriptionMeta) {
      twitterDescriptionMeta.setAttribute("content", twitterDescription);
    }

    // Update JSON-LD schema if it exists
    const jsonLdScript = document.querySelector(
      'script[type="application/ld+json"]'
    );
    if (jsonLdScript) {
      try {
        const schema = JSON.parse(jsonLdScript.textContent);
        if (schema.offers && schema.offers.description) {
          schema.offers.description = `Free delivery on orders above ₹${freeDeliveryThreshold}`;
          jsonLdScript.textContent = JSON.stringify(schema);
        }
      } catch (error) {
        console.warn("Could not update JSON-LD schema:", error);
      }
    }
  }, [getFreeDeliveryThreshold, getDeliveryLimit]);

  return null; // This component doesn't render anything
};

export default DynamicSEO;
